@if (title || subtitle) {
  <div class="spa-card-header">
    @if (title) {
      <div class="spa-card-header__title">{{ title }}</div>
    }
    @if (subtitle) {
      <div class="spa-card-header__subtitle">{{ subtitle }}</div>
    }
  </div>
}

<div class="spa-card__body">
  <ng-content></ng-content>
</div>
